// @ts-nocheck
import { createStyle } from '@gluestack-style/react';
import { BaseIconVariants } from './Icon';

export const ActionsheetIcon = createStyle({
  variants: BaseIconVariants,
  props: {
    size: 'sm',
  },
  color: '$backgroundLight500',
  _dark: {
    color: '$backgroundDark400',
  },
});
